import { faBars } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Portal from '@mui/material/Portal';
import React from 'react';

export interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  containerId: string;
}

export const Handle = ({ containerId, ...props }: Props) => {
  return (
    <button
      {...props}
      tabIndex={0}
      data-cy="draggable-handle-button"
      style={{
        cursor: 'grab',
        alignItems: 'center',
        touchAction: 'none',
        display: 'none',
      }}
    >
      <FontAwesomeIcon icon={faBars} size="xl" />
      <Portal container={document.getElementById(`${containerId}-handle`)}>
        <div>
          <FontAwesomeIcon icon={faBars} size="xl" />
        </div>
      </Portal>
    </button>
  );
};
